import { isEmpty, isNil } from 'lodash/fp';
import pt from 'prop-types';
import { Children, forwardRef, useEffect } from 'react';
import { MatrixHeaderWrapperElement } from '../styles';
import { renderOuterCell } from '../utils';

export const matrixHeaderFactory = ({ MatrixHeaderWrapper = MatrixHeaderWrapperElement } = {}) => {
    // @ts-expect-error $TSFixMeError: Property 'cellWidth' does not exist on type '{ children?: ReactNode; }'.
    const MatrixHeader = forwardRef(({ cellWidth, children, height, scrollPosition, width, ...headerProps }, ref) => {
        useEffect(() => {
            if (!isNil((ref as $TSFixMe).current)) {
                (ref as $TSFixMe).current.scrollLeft = scrollPosition;
            }
        }, [ref, scrollPosition]);

        if (isEmpty(children)) {
            return null;
        }

        const headerCells = Children.map(children, renderOuterCell({ cellHeight: height, cellWidth }));

        return (
            // @ts-expect-error $TSFixMeError: No overload matches this call.
            <MatrixHeaderWrapper height={height} ref={ref} width={width} {...headerProps}>
                {headerCells}
            </MatrixHeaderWrapper>
        );
    });

    MatrixHeader.propTypes = {
        // @ts-expect-error $TSFixMeError: Type '{ cellWidth: pt.Requireable<number | (number | null)[]>; children: pt.Requireable<pt.ReactNodeLike>; height: pt.Re...
        cellWidth: pt.oneOfType([pt.number, pt.arrayOf(pt.number)]),
        children: pt.node,
        height: pt.number,
        scrollPosition: pt.number,
    };

    return MatrixHeader;
};

export default matrixHeaderFactory();
